import React from 'react';
import {HashRouter, Route, Routes,BrowserRouter } from 'react-router-dom';
import Header from './Header';
import Home from './Home/Home';
import Contact from './Contact/Contact';
import About from './About/About';
import Page404 from './Page404';
import Services from './Service/Services';
import Portfolio from './Portfolio/Portfolio';
import TermsAndCondition from './Policy/TermsAndCondition';
import RefundPolicy from './Policy/RefundPolicy';
import PrivacyPolicy from './Policy/PrivacyPolicy';
import Footer from './Footer';
import CurserEffect from './CurserEffect';
import ProgressBar from './ProgressBar';
import MyAos from './MyAos';
import 'aos/dist/aos.css';


function App() {
  return (
    <>
      <HashRouter>
        <ProgressBar />
        <Header />
        <CurserEffect />
        <MyAos />
        <main id='content'>
          <Routes>
            <Route path='/' element={<Home />} />
            <Route path='/Contact' element={<Contact />} />
            <Route path='/About' element={<About />} />
            <Route path='/Services' element={<Services />} />
            <Route path='/Portfolio' element={<Portfolio />} />
            <Route path='/TermsAndCondition' element={<TermsAndCondition />} />
            <Route path='/RefundPolicy' element={<RefundPolicy />} />
            <Route path='/PrivacyPolicy' element={<PrivacyPolicy />} />
            <Route path='*' element={<Page404 />} />
          </Routes>
        </main>
        <Footer />
      </HashRouter>
    </>
  );
}
export default App;

